import type { CallEndedMessage } from '@vagusx/clients';
import { callEndReasonIcon, callEndReasonLabel } from './call-end-reason';

/**
 * Terminal marker at the bottom of a completed voice transcript: how the call
 * ended. Rendered as an understated centered separator — the point is that the
 * transcript never ends on a dangling line (a truncated goodbye after the
 * patient hangs up first reads as a mystery disconnect otherwise).
 *
 * `payload.reason` is the semantic category the voice runtime recorded — see
 * run.ts `toCallEndReason`. Label + icon both come from the shared
 * `call-end-reason.ts` meta map (single source of truth), each with a generic
 * fallback so an unknown/future reason renders rather than crashing the row.
 */
export function CallEndedRow({ event }: { event: CallEndedMessage }): React.ReactElement {
  const Icon = callEndReasonIcon(event.payload.reason);
  const label = callEndReasonLabel(event.payload.reason);
  return (
    <div className="my-2 flex items-center gap-2 text-xs text-muted-foreground">
      <span className="h-px flex-1 bg-border" />
      <span className="flex items-center gap-1.5">
        <Icon className="h-3 w-3" />
        {label}
      </span>
      <span className="h-px flex-1 bg-border" />
    </div>
  );
}
